import React from 'react';
import PropTypes from 'prop-types';
import FormTabsWithRequiredFields from 'components/form/localisation/FormTabsWithRequiredFields';
import LocalisationErrors from 'components/form/localisation/LocalisationErrors';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { change, getFormValues, unregisterField } from 'redux-form';
import { connect } from 'react-redux';

class RenderLocalisationInputField extends React.Component {
    constructor(props, context) {
        super(props, context);

        const {
            localisation,
        } = props;

        const {
            supported,
            system,
        } = context.config.language;

        let available = [
            ...supported,
        ];

        let selected = [
            system,
        ];

        // Remove the system language from the supportLanguages.
        if (~available.indexOf(system)) {
            available.splice(available.indexOf(system), 1);
        }

        if (localisation) {
            utils.each(localisation, (_, locale) => {
                const availableLocale = !!~available.indexOf(locale);

                if (availableLocale) {
                    const index = available.indexOf(locale);

                    available.splice(index, 1);
                    selected.push(locale);
                }
            });
        }

        this.state = {
            available: available,
            selected: selected,
            system: system,
        };
    }

    addLanguage = (key) => {
        // Adding the value to the selectedValues.
        this.setState((prevState) => {
            const filteredValues = prevState.available.filter((language) => {
                return language !== key;
            });

            return {
                available: filteredValues,
                selected: prevState.selected.concat([
                    key,
                ]),
            };
        });
    }

    removeLanguage = (language) => {
        const {
            changeFieldValue,
            fields,
        } = this.props;

        // Unregister the fields from the form.
        unregisterField(`localisation[${ language }]`);

        // This alters the Redux-form state for that specific language.
        fields.map((field) => {
            if (!field.name) {
                return;
            }

            changeFieldValue(language, null, field.name);
        });

        // Also removes the fallback description to fix the error when deleting a language
        changeFieldValue(language, null, 'fallback_description');

        // Removing the language to the selectedValues.
        this.setState((prevState) => {
            const filteredValues = prevState.selected.filter((val) => {
                return val !== language;
            });

            return {
                available: prevState.available.concat([
                    language,
                ]),
                selected: filteredValues,
            };
        });
    }

    render() {
        const {
            changeFieldValue,
            fields,
            form,
            formValues,
            maxLength,
            translate,
        } = this.props;

        const {
            available,
            selected,
            system,
        } = this.state;

        return (
            <div>
                <FormTabsWithRequiredFields
                    addTab={ this.addLanguage }
                    dialogLabel={ translate('localisations.dialog.label') }
                    fields={ fields }
                    formValues={ formValues }
                    locked={ system }
                    maxLength={ maxLength }
                    options={ available }
                    removeTab={ this.removeLanguage }
                    selected={ selected }
                    system={ system }
                    updateTranslation={ changeFieldValue }
                />

                <LocalisationErrors
                    baseLocale={ system }
                    fields={ fields }
                    form={ form }
                />
            </div>
        );
    }
}

RenderLocalisationInputField.contextTypes = {
    config: PropTypes.object,
};

RenderLocalisationInputField.defaultProps = {
    maxLength: 1000,
};

RenderLocalisationInputField.propTypes = {
    changeFieldValue: PropTypes.func.isRequired,
    fields: PropTypes.array,
    form: PropTypes.string,
    formValues: PropTypes.object,
    localisation: PropTypes.object,
    maxLength: PropTypes.number,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        formValues: getFormValues(form)(state),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        form,
    } = props;

    return {
        changeFieldValue: (target, value, type) => {
            const name = `localisation[${ target }][${ type }]`;

            dispatch(change(form, name, value));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(RenderLocalisationInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderLocalisationInputField.js